export const AD_MODAL_CONTENT_HEIGHT = "400px";
